import { render, staticRenderFns } from "./AuctionDesc.vue?vue&type=template&id=7b041286&scoped=true"
import script from "./AuctionDesc.vue?vue&type=script&lang=js"
export * from "./AuctionDesc.vue?vue&type=script&lang=js"
import style0 from "./AuctionDesc.vue?vue&type=style&index=0&id=7b041286&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b041286",
  null
  
)

export default component.exports